import * as Yup from 'yup';

export default Yup.object().shape({
  causedByCountyError: Yup.string(),
  paidInFull: Yup.string(),
  doesNotExceedPenalty: Yup.string(),
  assignedBecauseOfFailure: Yup.string(),
  noPenaltyUnderUCA: Yup.string(),
  filedDelinquentStatement: Yup.string(),
});
